"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrganizationDataLevelPipe = void 0;
//ANGULAR2 BITS
const core_1 = require("@angular/core");
const data_level_service_1 = require("./data-level.service");
let OrganizationDataLevelPipe = class OrganizationDataLevelPipe {
    constructor(_dataLevel) {
        this._dataLevel = _dataLevel;
    }
    transform(value) {
        if (value && Array.isArray(value)) {
            let dataLevel = this._dataLevel.get();
            return value.filter(item => {
                return item.type == dataLevel.slug;
            });
        }
    }
};
exports.OrganizationDataLevelPipe = OrganizationDataLevelPipe;
exports.OrganizationDataLevelPipe = OrganizationDataLevelPipe = __decorate([
    (0, core_1.Pipe)({ name: 'organizationDataLevel', pure: false }),
    __metadata("design:paramtypes", [data_level_service_1.DataLevelService])
], OrganizationDataLevelPipe);
//# sourceMappingURL=organization-data-level.pipe.js.map